import React, { useState } from 'react'
import axios from './shared/axios'
import Pagination from './shared/Pagination'
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from 'reactstrap'
import CloseButton from './shared/CloseButton'
import MonthCard from './TeamScheduled/MonthCard'

export default function TeamScheduledNext({ initialShares, basepath }) {
  const [shares, setShares] = useState(initialShares)
  const [deleteConfirmationVisible, setDeleteConfirmationVisible] = useState(false)
  const [deleting, setDeleting] = useState(false)
  const [shareToDelete, setShareToDelete] = useState(null)

  const toggleDeleteConfirmation = () => setDeleteConfirmationVisible(!deleteConfirmationVisible)

  const deleteShare = (shareId) => {
    setShareToDelete(shareId)
    toggleDeleteConfirmation()
  }

  const deleteSelectedShare = async () => {
    setDeleting(true)
    await axios.delete(`${basepath}/${shareToDelete}.json`)
    setShareToDelete(null)
    getPage(shares.data.length == 1 ? Math.max(shares.currentPage - 1, 1) : shares.currentPage)
    setDeleting(false)
    toggleDeleteConfirmation()
  }

  const getPage = async (page) => {
    const response = await axios.get(`${basepath}/scheduled.json`, { params: { page } })
    setShares(response.data)
  }

  const sortedShares = shares.data
    .map((share) => ({...share,scheduled_at: new Date(share.scheduled_at)}))
    .sort((a, b) => a.scheduled_at - b.scheduled_at || b.id - a.id)

  const sharesByMonth = Object.groupBy(sortedShares, share => share.scheduled_at.toLocaleString('default', { month: 'long', year: 'numeric' }))

  return (
    <div>
      {sortedShares.length == 0 && (
        <div className="card card-empty mb-4">
          <div className="card-body">
            No posts have been scheduled
          </div>
        </div>
      )}
      {Object.entries(sharesByMonth).map(([monthName, shares]) => (
        <MonthCard key={monthName} monthName={monthName} shares={shares} basepath={basepath} deleteShare={deleteShare} />
      ))}
      <Modal isOpen={deleteConfirmationVisible} toggle={toggleDeleteConfirmation}>
        <ModalHeader toggle={toggleDeleteConfirmation} close={<CloseButton onClick={toggleDeleteConfirmation} />} tag="h4" className="modal-header-segmented">
          Delete this Scheduled Post?
        </ModalHeader>
        <ModalBody>
          Are you sure you want to delete this scheduled post?
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={deleteSelectedShare} disabled={deleting}>{deleting ? 'Deleting…' : 'Delete'}</Button>
          <Button color="outline-secondary" onClick={toggleDeleteConfirmation} disabled={deleting}>Cancel</Button>
        </ModalFooter>
      </Modal>
      <Pagination currentPage={shares.currentPage} pageCount={shares.pageCount} onPageChange={getPage} />
    </div>
  )
}